module.exports = __webpack_public_path__ + "img/icon_map_jxs.31410c6a.png";